import type { JobStatus } from '../../types'

export const JOB_STATUS_LABEL: Record<JobStatus, string> = {
  'on-track': 'On Track',
  'due-soon': 'Due Soon',
  'over-budget': 'Over Budget',
  'needs-staff': 'Needs Staff',
  blocked: 'Blocked',
}

export function getWorkflowBadgeClass(status: JobStatus) {
  if (status === 'on-track') return 'badge-green'
  if (status === 'due-soon') return 'badge-amber'
  if (status === 'over-budget' || status === 'blocked') return 'badge-red'
  return 'badge-blue'
}

export function formatWorkflowHours(value: number | null | undefined) {
  if (value == null || !Number.isFinite(value)) return '—'
  return Number.isInteger(value) ? `${value}` : value.toFixed(1)
}

export function formatShortDate(value: string | null | undefined) {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return '—'
  const day = new Intl.DateTimeFormat(undefined, { day: 'numeric' }).format(date)
  const month = new Intl.DateTimeFormat(undefined, { month: 'short' }).format(date)
  const year = new Intl.DateTimeFormat(undefined, { year: 'numeric' }).format(date)
  return `${day} ${month} ${year}`
}

